interface StandardGradeItem {
  type: string;
  total: number;
  listening: number;
  reading: number;
  writing: number;
  speaking: number;
}

export const ENGLISH_TESTING_TYPES = ['ielts', 'toefl', 'pte', 'duolingo_english_test', 'duolingo'];
const isEnglishTestingType = (type: string) => ENGLISH_TESTING_TYPES.includes(type);

export default class EnglishConverter {
  static is = isEnglishTestingType;
  static isValid = (item: StandardGradeItem) => {
    return item.total > 0 || item.listening > 0 || item.reading > 0 || item.writing > 0 || item.speaking > 0;
  };

  static toArray(resume: Record<string, any>): StandardGradeItem[] {
    return ENGLISH_TESTING_TYPES.map((type) => {
      const typeObj = resume[`${type}_test_score`];
      if (typeObj) return { type, ...typeObj };

      const total = resume[`${type}`] || null;
      const listening = resume[`${type}_listening`] || null;
      const reading = resume[`${type}_reading`] || null;
      const writing = resume[`${type}_writing`] || null;
      const speaking = resume[`${type}_speaking`] || null;
      return { type, total, listening, reading, writing, speaking };
    });
  }

  static toValidArray(resume: Record<string, any>): StandardGradeItem[] {
    const items = this.toArray(resume);
    return items.filter(this.isValid);
  }

  static toObject(items: StandardGradeItem[]) {
    const resume = {};
    items.forEach((item) => {
      const { type, total, listening, reading, writing, speaking } = item;
      resume[`${type}`] = total;
      resume[`${type}_listening`] = listening;
      resume[`${type}_reading`] = reading;
      resume[`${type}_writing`] = writing;
      resume[`${type}_speaking`] = speaking;

      // new version[toefl_test_score/pte_score/ielts_score/duolingo_english_test_score]
      resume[`${type}_test_score`] = {
        total,
        listening,
        reading,
        writing,
        speaking,
      };
    });
    return resume;
  }

  static defaults() {
    return {
      toefl: null,
      pte: null,
      ielts: null,
      duolingo_english_test: null,
      toefl_listening: null,
      toefl_reading: null,
      toefl_writing: null,
      toefl_speaking: null,
      pte_listening: null,
      pte_reading: null,
      pte_writing: null,
      pte_speaking: null,
      ielts_listening: null,
      ielts_reading: null,
      ielts_writing: null,
      ielts_speaking: null,
      duolingo_english_test_listening: null,
      duolingo_english_test_reading: null,
      duolingo_english_test_writing: null,
      duolingo_english_test_speaking: null,

      // new version[toefl_test_score/pte_score/ielts_score/duolingo_english_test_score]
      toefl_test_score: {
        total: null,
        listening: null,
        reading: null,
        writing: null,
        speaking: null,
      },
      pte_test_score: {
        total: null,
        listening: null,
        reading: null,
        writing: null,
        speaking: null,
      },
      ielts_test_score: {
        total: null,
        listening: null,
        reading: null,
        writing: null,
        speaking: null,
      },
      duolingo_test_score: {
        total: null,
        listening: null,
        reading: null,
        writing: null,
        speaking: null,
      },
    };
  }
}
